"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiBase = void 0;
const types_1 = require("@helpasaur/types");
/**
 * Base class providing common API functionality and helper methods
 * for all route-specific API classes
 */
class ApiBase {
    api;
    constructor(api) {
        this.api = api;
    }
    /**
     * Helper function to handle API responses that return data
     * @param response - The axios response object
     * @returns The data from the response
     * @throws Error if the response indicates an error
     */
    handleDataResponse(response) {
        if (response.data.result === types_1.ApiResult.ERROR) {
            throw new Error(response.data.message || "API request failed");
        }
        if (response.data.result === types_1.ApiResult.SUCCESS &&
            response.data.data !== undefined) {
            return response.data.data;
        }
        // Handle NOOP or SUCCESS without data - should not happen for data responses
        throw new Error(response.data.message || "No data returned from API");
    }
    /**
     * Helper function to handle API responses that return void
     * @param response - The axios response object
     * @throws Error if the response indicates an error
     */
    handleVoidResponse(response) {
        if (response.data.result === types_1.ApiResult.ERROR) {
            throw new Error(response.data.message || "API request failed");
        }
        // SUCCESS and NOOP are both treated as success for void operations
    }
    /**
     * Helper function to execute GET requests
     * @param endpoint - The API endpoint to call
     * @returns Promise with the data from the response
     */
    async apiGet(endpoint) {
        const response = await this.api.get(endpoint);
        return this.handleDataResponse(response);
    }
    /**
     * Helper function to execute POST requests
     * @param endpoint - The API endpoint to call
     * @param data - The data to send in the request body
     * @returns Promise with the data from the response or void
     */
    async apiPost(endpoint, data) {
        const response = await this.api.post(endpoint, data);
        return this.handleResponse(response);
    }
    /**
     * Helper function to execute PATCH requests
     * @param endpoint - The API endpoint to call
     * @param data - The data to send in the request body
     * @returns Promise with the data from the response or void
     */
    async apiPatch(endpoint, data) {
        const response = await this.api.patch(endpoint, data);
        return this.handleResponse(response);
    }
    /**
     * Helper function to execute DELETE requests
     * @param endpoint - The API endpoint to call
     * @param data - Optional data to send in the request body
     * @returns Promise with void
     */
    async apiDelete(endpoint, data) {
        const response = await this.api.delete(endpoint, data ? { data } : undefined);
        return this.handleResponse(response);
    }
    /**
     * Generic response handler that works for both data and void responses
     * @param response - The axios response object
     * @returns The data from the response or void
     */
    handleResponse(response) {
        if (response.data.result === types_1.ApiResult.ERROR) {
            throw new Error(response.data.message || "API request failed");
        }
        if (response.data.result === types_1.ApiResult.SUCCESS) {
            return response.data.data;
        }
        // NOOP is treated as success
        return response.data.data;
    }
}
exports.ApiBase = ApiBase;
//# sourceMappingURL=index.js.map